import React from "react";

import { TvSeriesProvider } from "./details/context/TvSeriesProvider";
import { TvSeriesDashboardPages } from "./details/TvSeriesDashboardPages";
import { TvSeriesDashboardHeader } from "./TvSeriesDashboardHeader";
import { TvSeriesDashboardProvider } from "./TvSeriesDashboardProvider";

export const TvSeriesDashboard: React.FunctionComponent = () => {
    return (
        <TvSeriesProvider>
            <TvSeriesDashboardProvider>
                <TvSeriesDashboardHeader />
                <TvSeriesDashboardPages />
            </TvSeriesDashboardProvider>
        </TvSeriesProvider>
    );
};
